import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { ProductBlockContainerError } from '../ProductBlockContainerError/ProductBlockContainerError.js';
import { ProductBlockContainerLoader } from '../ProductBlockContainerLoader/ProductBlockContainerLoader.js';
import { ProductBlockCarousel } from './components/ProductBlockCarousel/ProductBlockCarousel.js';
import { ProductBlockSlider } from './components/ProductBlockSlider/ProductBlockSlider.js';

var ProductBlockGallery = (_param)=>{
    var { isLoading , hasError  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "isLoading",
        "hasError"
    ]);
    const isBigScreen = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    if (isLoading) {
        return /*#__PURE__*/ React.createElement(ProductBlockContainerLoader, null);
    }
    if (hasError) {
        return /*#__PURE__*/ React.createElement(ProductBlockContainerError, null);
    }
    if (isBigScreen) {
        return /*#__PURE__*/ React.createElement(ProductBlockCarousel, swcHelpers.extends({}, props));
    }
    return /*#__PURE__*/ React.createElement(ProductBlockSlider, swcHelpers.extends({}, props));
};

export { ProductBlockGallery };
//# sourceMappingURL=ProductBlockGallery.js.map
